import React from "react";
import ImageV3 from "src/components/image/image.v3";

const SingleImage = ({ moduleData, overlayColorWithTransparency, image }) => {
    let rounding = "";
    if (moduleData.roundedCorners && moduleData.width !== 'full_screen') rounding = "rounded-xl";

    return (
        <div
            className={`hero-layer absolute top-0 left-0 right-0 bottom-0 w-full h-full -z-10 ${rounding} overflow-hidden`}
            style={{ '--overlayColor': overlayColorWithTransparency }}
        >
                <ImageV3
                    image={image.directus_files_id}
                    alt={image.directus_files_id.title + ''}
                    className={`w-full h-full ${rounding}`}
                    imgStyle={{ objectFit: "cover", objectPosition: moduleData.backgroundImagePosition + " center" }}
                    draggable={false}
                    loading="eager"
                />

                <div className={`hero-layer absolute top-0 left-0 right-0 bottom-0 inset-0 bg-[color:var(--overlayColor)] overflow-hidden`}/>
        </div>
    )
}


export default SingleImage;